import React, { useRef, useEffect, useState } from "react";
import Taller from "views/Components/ServicesOperationComponent/Taller/Taller";
import { useParams } from "react-router-dom";
import { Stack, Typography } from "@mui/material";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";

const ServiceOperationTaller = (props) => {
  const { id } = useParams();

  const divRef = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    // size update
    const updateSize = () => {
      if (divRef.current) {
        const { width, height } = divRef.current.getBoundingClientRect();
        setSize({ width, height });
      }
    };

    // set initial size
    updateSize();

    window.addEventListener("resize", updateSize);

    // remove event controller
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return (
    <div ref={divRef}>
      <Stack spacing={1}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            fontSize: "32px",
            color: "#000000DE",
            lineHeight: "24px",
          }}
        >
          Tickets de reparación
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            fontSize: "14px",
            color: "#000000DE",
            lineHeight: "24px",
          }}
        >
          SOR · Técnico
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={0.5} mt={2}>
        <LayersOutlinedIcon
          sx={{
            width: "24px",
            height: "24px",
            fill: "#00000099",
          }}
        />
        <Typography>Reparaciones</Typography>
      </Stack>
      <Taller id={id} />
    </div>
  );
};

export default ServiceOperationTaller;
